import React from "react";

import { TabPanelContainer } from "./styles";

interface TabPanelProps {
  id: string;
  value: number;
  index: number;
}

const TabPanel: React.FC<TabPanelProps> = ({
  id,
  children,
  value,
  index,
  ...rest
}) => (
  <TabPanelContainer
    role="tabpanel"
    hidden={value !== index}
    id={`${id}-${index}`}
    aria-labelledby={`${id}-${index}`}
    {...rest}
  >
    {/* {value === index && children } */}
    {children}
  </TabPanelContainer>
);

export default TabPanel;
